import { Sprout, BadgeCheck, Landmark, Package, HeartHandshake, MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const ITEMS = [
  {
    icon: Sprout,
    title: "Authentic Sourcing",
    text: "Focused on carefully selected ingredients and products.",
  },
  {
    icon: BadgeCheck,
    title: "Quality Focused",
    text: "Quality is considered at every stage, from sourcing to packaging.",
  },
  {
    icon: Landmark,
    title: "Traditional Inspiration",
    text: "Rooted in India's rich food and agricultural heritage.",
  },
  {
    icon: Package,
    title: "Premium Presentation",
    text: "A modern experience built for today's customer.",
  },
  {
    icon: HeartHandshake,
    title: "Customer First",
    text: "Responsive service and direct customer communication.",
  },
  {
    icon: MapPin,
    title: "Made in India",
    text: "Indian roots with ambitions for a global customer base.",
  },
];

export default function Different() {
  return (
    <section id="difference" data-testid="different-section" className="bg-ivory py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="The Difference" title="What Makes MAHIRA Different?" />
        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`different-card-${item.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group h-full rounded-3xl border border-forest/10 bg-white/60 p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_30px_60px_-25px_rgba(26,54,38,0.25)]"
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-forest text-gold-light transition-colors duration-500 group-hover:bg-gold group-hover:text-forest">
                  <item.icon className="h-5 w-5" />
                </span>
                <h3 className="mt-7 font-heading text-2xl text-forest">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/65">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
